import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Col, Icon, Row, RSelect } from '../Component';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_tenant_order_approvers_and_sales_reps, loading_retrieve_tenant_order_approvers_and_sales_reps, reset_retrieve_tenant_order_approvers_and_sales_reps, success_retrieve_tenant_order_approvers_and_sales_reps } from '../../reducers/auth_tenant/retrieve_tenant_order_approvers_and_sales_reps_Slice';
import { RETRIEVE_TENANT_AGENCY_MAIN_SALES_REP_DETAILS_ERROR_MSG, RETRIEVE_TENANT_AGENCY_MAIN_SALES_REP_DETAILS_SUCCESS_MSG, RETRIEVE_TENANT_ORDER_APPROVALS_AND_SALES_REPRESENTATIVES_ERROR_MSG, RETRIEVE_TENANT_ORDER_APPROVALS_AND_SALES_REPRESENTATIVES_SUCCESS_MSG, RETRIEVE_TENANT_UPDATE_AGENCY_MAIN_SALES_REP_ERROR_MSG, RETRIEVE_TENANT_UPDATE_AGENCY_MAIN_SALES_REP_SUCCESS_MSG } from '../../utils/error_success_messages';
import { RETRIEVE_TENANT_AGENCY_MAIN_SALES_REP_DETAILS_API, RETRIEVE_TENANT_APPROVERS_AND_SALES_REP_API, TENANT_UPDATE_AGENCY_MAIN_SALES_REP_API } from '../../api/api_data';
import * as app_consts from "../../utils/app_consts";
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';
import TextInput from '../../pages/components/inputs/TextInput';
import { fail_tenant_add_sales_rep_to_agency, loading_tenant_add_sales_rep_to_agency, reset_tenant_add_sales_rep_to_agency, success_tenant_add_sales_rep_to_agency } from '../../reducers/auth_tenant/tenant_add_sales_rep_to_agency_Slice';
import { useParams } from 'react-router';
import { fail_retrieve_tenant_agency_main_sales_rep_details, loading_retrieve_tenant_agency_main_sales_rep_details, reset_retrieve_tenant_agency_main_sales_rep_details, success_retrieve_tenant_agency_main_sales_rep_details } from '../../reducers/auth_tenant/retrieve_tenant_agency_main_sales_rep_details_Slice';
import { fail_tenant_update_agency_main_sales_rep, loading_tenant_update_agency_main_sales_rep, reset_tenant_update_agency_main_sales_rep, success_tenant_update_agency_main_sales_rep } from '../../reducers/auth_tenant/tenant_update_agency_main_sales_rep_Slice';

const initial_state = { sales_rep_id: "" };

const ViewAgencyMainSalesRepModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction }) => {

 const { id } = useParams();

 const [page_data, setPageData] = useState([]);
 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");
 const [retrieved_data, setRetrievedData] = useState([]);
 const dispatch = useDispatch();
 const [editMode, setEditMode] = useState(false);
 const [sales_reps_data, setSalesRepsData] = useState([]);
 const [current_sales_reps_data, setCurrentSalesRepsData] = useState([]);
 const [formData, setFormData] = useState(initial_state);

 const [update_loading, setUpdateLoading] = useState(false);
 const [update_error, setUpdateError] = useState("");


 useEffect(() => {
  if (isOpen)
  {
   setFormData(initial_state);
   // Dispatch
   retrieve_main_sales_reps_settings();
  }
  setOpen(isOpen);
 }, [isOpen]);



 const retrieve_main_sales_reps_settings = () => {
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_agency_main_sales_rep_details, success_retrieve_tenant_agency_main_sales_rep_details, fail_retrieve_tenant_agency_main_sales_rep_details, RETRIEVE_TENANT_AGENCY_MAIN_SALES_REP_DETAILS_ERROR_MSG, RETRIEVE_TENANT_AGENCY_MAIN_SALES_REP_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_AGENCY_MAIN_SALES_REP_DETAILS_API}/${id}`));
 };

 // Listener
 const retrieve_tenant_agency_main_sales_rep_details_listener = useSelector((state) => state.retrieve_tenant_agency_main_sales_rep_details.retrieve_tenant_agency_main_sales_rep_details);

 useEffect(() => {
  if (retrieve_tenant_agency_main_sales_rep_details_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_agency_main_sales_rep_details_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (retrieve_tenant_agency_main_sales_rep_details_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(retrieve_tenant_agency_main_sales_rep_details_listener.message);
     messageToast(retrieve_tenant_agency_main_sales_rep_details_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_agency_main_sales_rep_details_listener.status === app_consts.SUCCESS)
    {
     const remapped_sales_reps = retrieve_tenant_agency_main_sales_rep_details_listener.data?.sales_reps?.map((rep) => {
      return {
       label: `${rep?.name} - ${rep?.mobile_number}`,
       value: rep?.id
      };
     });
     setSalesRepsData(remapped_sales_reps);

     setRetrievedData(retrieve_tenant_agency_main_sales_rep_details_listener.data);
     const timer = setTimeout(() => {
      setLoading(false);
     }, 1000);

     return () => clearTimeout(timer); // cleanup in case the component unmounts
    }
    dispatch(reset_retrieve_tenant_agency_main_sales_rep_details());
   }
  }
 }, [retrieve_tenant_agency_main_sales_rep_details_listener]);

 const getSelectedOption = (value, options) => {
  return options?.find(option => option.value === value) || null;
 };

 const handleUpdateMainSalesRep = () => {
  setUpdateError("");
  const sent_data = { ...formData, id: id };
  dispatch(tenant_auth_actions_helper(loading_tenant_update_agency_main_sales_rep, success_tenant_update_agency_main_sales_rep, fail_tenant_update_agency_main_sales_rep, RETRIEVE_TENANT_UPDATE_AGENCY_MAIN_SALES_REP_ERROR_MSG, RETRIEVE_TENANT_UPDATE_AGENCY_MAIN_SALES_REP_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_AGENCY_MAIN_SALES_REP_API}`, sent_data));
 };
 const tenant_update_agency_main_sales_rep_listener = useSelector((state) => state.tenant_update_agency_main_sales_rep.tenant_update_agency_main_sales_rep);

 useEffect(() => {
  if (tenant_update_agency_main_sales_rep_listener.status !== app_consts.IDLE)
  {
   if (tenant_update_agency_main_sales_rep_listener.status === app_consts.LOADING)
   {
    setUpdateLoading(true);
    setUpdateError("");
   } else
   {
    if (tenant_update_agency_main_sales_rep_listener.status === app_consts.FAIL)
    {
     setUpdateLoading(false);
     setUpdateError(tenant_update_agency_main_sales_rep_listener.message);
     messageToast(tenant_update_agency_main_sales_rep_listener.message, app_consts.FAIL);
    } else if (tenant_update_agency_main_sales_rep_listener.status === app_consts.SUCCESS)
    {
     successFunction();
     retrieve_main_sales_reps_settings();
     setEditMode(false);
    }
    dispatch(reset_tenant_update_agency_main_sales_rep());
   }
  }
 }, [tenant_update_agency_main_sales_rep_listener]);


 return (
  <>
   <Modal isOpen={open} toggle={update_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"md "}>
    <ModalHeader toggle={update_loading || loading ? "" : closeModal}>Agency Main Sales Rep</ModalHeader>
    <ModalBody>
     {
      loading ?
       <>
        <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
         <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieving Main Sales Rep Details...</div>
         <div className="nk-loader mt-2  w-70 m-auto "></div>
        </div>
       </>
       :
       <>
        {
         error ?
          <>
           <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
            <div className="text-soft fw-bold" style={{ fontSize: 16, marginTop: "90px" }}>{error}</div>
           </div>
          </>
          :
          <>
           <div className='mt-4'>
           </div>
           {
            editMode ?
             <>
              <Row className="g-4">
               <Col lg={12}>
                <div className="form-group">
                 <div className="form-label-group">
                  <label className="form-label">
                   <label className="form-label mb text-md" htmlFor="retrunable">
                    Main Sales Rep<span className='text-danger pr-2'>{` *`}</span>
                   </label>
                  </label>
                 </div>
                 <div className="w-100">
                  <RSelect
                   options={sales_reps_data}
                   className="w-100"
                   placeholder="Search"
                   value={getSelectedOption(formData?.sales_rep_id, sales_reps_data)}
                   onChange={(e) => setFormData({ ...formData, sales_rep_id: e.value })}
                  />
                 </div>
                </div>
               </Col>
              </Row>
              <hr />
              <Row className="g-4 mt-4">
               {update_error && (
                <div className="mb-3 w-100">
                 <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" /> {update_error}{" "}
                 </Alert>
                </div>
               )}
               <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                <Button className='mx-2' onClick={() => setEditMode(false)} disabled={update_loading} color="gray">
                 Cancel
                </Button>
                <Button onClick={handleUpdateMainSalesRep} disabled={
                 (update_loading) ||
                 !(formData?.sales_rep_id)
                } color="primary">
                 {update_loading ? <Spinner size="sm" color="light" /> : "Update Main Sales Rep"}
                </Button>
               </Col>
              </Row>
             </>
             :
             <>
              {
               retrieved_data?.main_sales_rep ?
                <>
                 <div className="m-auto d-flex flex-row justify-content-start align-center my-4" >
                  <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData({ initial_state }); }} color="primary" size="sm">
                   Edit Main Sales Rep
                  </Button>
                 </div>
                 <Row className="g-4">
                  <TextInput
                   label="Main Sales Rep"
                   type="text"
                   id_val="sales_rep_id"
                   value={retrieved_data?.main_sales_rep ? `${retrieved_data?.main_sales_rep?.name} ${retrieved_data?.main_sales_rep?.mobile_number}` : "--"}
                   colSize="12"
                   disabled
                   name="sales_rep_id"
                  />
                 </Row>
                </>
                :
                <>
                 <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold my-4" style={{ fontSize: 18 }}>Main Sales Rep has not Been Set</div>
                  <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData(initial_state); }} color="primary" size="sm">
                   Add Main Sales Rep
                  </Button>
                 </div>
                </>
              }
             </>
           }
          </>
        }
       </>
     }
    </ModalBody>
   </Modal>
  </>
 );
};

export default ViewAgencyMainSalesRepModal;